import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import DashboardSkeleton from "../../common/DashboardSkeleton";
import overdue from "../../assets/overdue.jpg";
import working from "../../assets/working.jpg";
import critical from "../../assets/critical.jpg";
import duesoon from "../../assets/duesoon.jpg";
import formatDateAndTime from "../../common/formatDateAndTime";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

const Accidents = ({ setSavedAmount, cityFilter }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [accidentsData, setAccidentsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("All");
  const [searchText, setSearchText] = useState("");
  const rowsPerPage = 10;
  const workorderStatusValue = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;

  const handleCopy = async (text, label) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(String(text));
      toast.success(`${label} copied to clipboard`);
    } catch (err) {
      toast.error(`Failed to copy ${label.toLowerCase()}`);
    }
  };

  const totalPages = Math.max(
    1,
    Math.ceil(accidentsData?.serviceList?.rows?.length / rowsPerPage),
  );
  const startIndex = (currentPage - 1) * rowsPerPage;
  const filteredRows = (accidentsData?.serviceList?.rows || []).filter(
    (data) => {
      const searchValue = searchText.trim().toLowerCase();

      if (!searchValue) {
        return true;
      }

      return [data?.serviceCode, data?.licensePlate]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(searchValue));
    },
  );
  const paginatedVehicles = filteredRows.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  const getAccidentsData = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    // const formattedStartDate = formatDateForApi(
    //   selectionRange?.startDate,
    //   "start",
    // );
    // const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query = "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&cityId=${cityFilter}`;
    }
    // ?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/accidental-repair?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAccidentsData(data?.dataValues);
        setCurrentPage(1);
        setSavedAmount(data?.dataValues?.metricsSummary?.savedAmount);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    getAccidentsData();
  }, [cityFilter]);

  const accidentsOverviewData = {
    counts: [
      {
        title: "Accident Cases",
        value: accidentsData?.metricsSummary?.accidentCases || 0,
        image: overdue,
        outof: "total",
        class: "text-black",
        bg: "bg-red-400",
      },
      {
        title: "Insurance Claims",
        value: "₹ " + accidentsData?.metricsSummary?.insuranceClaims || 0,
        image: working,
        outof: "total",
        class: "text-black",
        bg: "bg-blue-400",
      },
      {
        title: "Company Paid",
        value: "₹ " + accidentsData?.metricsSummary?.companyPaid || 0,
        image: duesoon,
        outof: "total",
        class: "text-black",
        bg: "bg-orange-400",
      },
      {
        title: "Customer Paid",
        value: "₹ " + accidentsData?.metricsSummary?.customerPaid || 0,
        image: critical,
        outof: "total",
        class: "text-black",
        bg: "bg-green-400",
      },
      {
        title: "Loss for Company",
        value: "₹ " + accidentsData?.metricsSummary?.lossForCompany || 0,
        image: working,
        outof: "CO Paid + INS Claimed - Total Dispersed Amt",
        class: "text-black",
        bg: "bg-red-400",
      },
    ],
    countstwo: [
      {
        title: "Damage Charges Collected",
        value:
          "₹ " + accidentsData?.metricsSummary?.totalDamageChargesCollected ||
          0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-red-400",
      },
      {
        title: "Downtime Charges Collected",
        value:
          "₹ " + accidentsData?.metricsSummary?.totalDowntimeChargesCollected ||
          0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-red-400",
      },
      {
        title: "Total Vehicles",
        value: accidentsData?.metricsSummary?.statusCounts?.totalVehicles || 0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-yellow-400",
      },
      {
        title: "Insurance Disperesed Amount",
        value: "₹ " + accidentsData?.metricsSummary?.totalDispersedAmount || 0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-green-400",
      },
      {
        title: "Payment Completed",
        value:
          "₹ " + accidentsData?.metricsSummary?.totalAmountPaidByCompany || 0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-blue-400",
      },
      {
        title: "Payment Pending",
        value:
          "₹ " + accidentsData?.metricsSummary?.totalPaymentPendingForCompany ||
          0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-orange-400",
      },
    ],
  };

  const handleDownload = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <>
      {loading ? (
        <div className="w-full">
          <DashboardSkeleton />
        </div>
      ) : (
        <>
          <div className="w-full p-2 inline-flex flex-col justify-start items-start gap-6 overflow-hidden">
            <div className="self-stretch h-32 inline-flex justify-start items-start gap-5">
              {accidentsOverviewData &&
                accidentsOverviewData.counts.map((data, index) => (
                  <div className="flex-1 h-32 p-5 relative bg-white rounded-bl-xl rounded-br-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-4">
                    <div
                      className={`w-[92%] h-2 left-[10px] top-0 absolute rounded-bl-lg rounded-br-lg ${data?.bg}`}
                    />
                    <div className="self-stretch inline-flex justify-between items-center">
                      <div className="justify-start text-slate-500 text-xs font-semibold font-['Inter'] uppercase">
                        {data?.title}
                      </div>
                      <div className="size-4 relative overflow-hidden">
                        <img src={data?.image} />
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-1">
                      <div className="justify-start text-slate-900 text-xl font-bold font-['Inter']">
                        {data?.value}
                      </div>
                      <div className="self-stretch justify-start text-slate-400 text-[10px] font-normal font-['Inter'] leading-4">
                        {data?.outof}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="self-stretch inline-flex justify-start items-start gap-2.5 overflow-hidden">
              {accidentsOverviewData &&
                accidentsOverviewData?.countstwo?.map((data, index) => (
                  <div className="flex-1 p-4 relative bg-white rounded-2xl border-l border-r border-t-[1.60px] border-b border-slate-200 inline-flex flex-col justify-start items-start gap-2 overflow-hidden">
                    <div
                      className={`w-full h-1 left-0 top-0 absolute ${data?.bg}`}
                    />
                    <div className="self-stretch justify-start text-slate-500 text-[10px] font-semibold font-['Inter'] tracking-wide">
                      {data?.title}
                    </div>
                    <div className="self-stretch justify-start text-slate-900 text-xl font-bold font-['Inter']">
                      {data?.value}
                    </div>
                    {/* <div className="self-stretch justify-start text-slate-400 text-xs font-normal font-['Inter']">
            Pending settlement
          </div> */}
                  </div>
                ))}
            </div>
            <div className="self-stretch p-4 bg-amber-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-amber-100 inline-flex justify-start items-center gap-3">
              <div className="size-6 bg-amber-600 rounded-xl flex justify-center items-center">
                <div className="size-3.5 relative overflow-hidden">
                  <div className="w-3 h-2.5 left-[1.16px] top-[1.74px] absolute outline outline-2 outline-offset-[-1px] outline-white" />
                </div>
              </div>
              <div className="flex-1 justify-start">
                <span class="text-amber-800 text-sm font-bold font-['Inter'] leading-5">
                  Accident + Insurance Cases Count:{" "}
                </span>
                <span class="text-amber-800 text-sm font-normal font-['Inter'] leading-5">
                  {
                    accidentsData?.metricsSummary
                      ?.totalIncurenceAndAccidentCase
                  }
                </span>
              </div>
              <div className="w-[464px] justify-start">
                <span class="text-amber-800 text-sm font-normal font-['Inter'] leading-5">
                  {
                    accidentsData?.metricsSummary?.downtimeMetrics
                      ?.totalAccidents
                  }{" "}
                  accidents × avg{" "}
                  {accidentsData?.metricsSummary?.downtimeMetrics
                    ?.avgDowntimeDays || 0}{" "}
                  days ={" "}
                </span>
                <span class="text-amber-800 text-sm font-bold font-['Inter'] leading-5">
                  ₹{" "}
                  {accidentsData?.metricsSummary?.downtimeMetrics
                    ?.totalDowntimeLoss || 0}
                </span>
                <span class="text-amber-800 text-sm font-normal font-['Inter'] leading-5">
                  {" "}
                  in downtime losses alone.
                </span>
              </div>
            </div>
            <div className="self-stretch bg-white rounded-xl border border-slate-200 overflow-hidden">
              <div className="flex items-center justify-between p-5 gap-3 flex-wrap">
                <h2 className="text-sm font-bold tracking-tight text-slate-900">
                  ACCIDENT REGISTER — ALL VEHICLES
                </h2>
                <div className="flex items-center gap-3 flex-wrap">
                  <input
                    type="text"
                    value={searchText}
                    onChange={(event) => setSearchText(event.target.value)}
                    placeholder="Search vehicle no or code"
                    className="px-3 py-2 border border-slate-300 rounded-md text-sm outline-none focus:border-blue-500"
                  />
                  <div className="px-4 py-2 border border-slate-200 rounded-lg text-sm font-semibold">
                    Total Count: {filteredRows.length}
                  </div>
                  <div className="p-1 bg-[#f1f5f9] rounded-lg inline-flex items-center gap-0.5">
                    <div
                      title="Download Full Report"
                      className="cursor-pointer"
                      onClick={() => {
                        handleDownload(accidentsData?.reportUrl);
                      }}
                    >
                      <DownloadForOfflineIcon />
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full overflow-x-auto">
                <table className="min-w-max w-full text-left border-collapse">
                  <thead>
                    <tr className="border-t border-b border-slate-200/80 bg-white">
                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        CODE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        VEHICLE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        SERVICE STATUS
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        CREATION DATE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        BLOCK START DATE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        BLOCK END DATE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        START ODOMETER
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        END ODOMETER
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap text-right">
                        PAYMENT STATUS
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap text-right">
                        OUTSTANDING BALANCE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap text-right">
                        INSURANCE CLAIM
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap text-right">
                        COMPANY PAID
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap text-center">
                        CUSTOMER PAID
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        DOWNTIME
                      </th>
                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        IS CREDIT APPLIED
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-slate-100">
                    {filteredRows.length === 0 ? (
                      <tr>
                        <td
                          colSpan={12}
                          className="px-6 py-12 text-center text-xs text-slate-400"
                        >
                          No Data Found
                        </td>
                      </tr>
                    ) : (
                      paginatedVehicles.map((data, index) => (
                        <tr
                          key={`${data?.serviceCode || index}-${index}`}
                          className="hover:bg-slate-50/50 transition-colors"
                        >
                          {/* CODE */}
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap">
                            <div className="inline-flex items-center gap-1.5">
                              <span>{data?.serviceCode || "-"}</span>

                              {data?.serviceCode && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleCopy(data?.serviceCode, "Code")
                                  }
                                  title="Copy Code"
                                  className="p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      x="8"
                                      y="8"
                                      rx="2"
                                      ry="2"
                                    />
                                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </td>
                          {/* VEHICLE */}
                          <td className="px-6 py-4 text-[12px] font-bold text-slate-900 whitespace-nowrap">
                            <div className="inline-flex items-center gap-1.5">
                              <span>{data?.licensePlate || "-"}</span>

                              {data?.licensePlate && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleCopy(data?.licensePlate, "Vehicle")
                                  }
                                  title="Copy Vehicle No"
                                  className="p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      x="8"
                                      y="8"
                                      rx="2"
                                    />
                                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {workorderStatusValue[data?.serviceStatus] || "-"}
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {formatDateAndTime(data?.createdAt) || "-"}
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {formatDateAndTime(data?.startDate) || "-"}
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {formatDateAndTime(data?.endDate) || "-"}
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {" "}
                            <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-blue-50 border border-blue-200">
                              {" "}
                              {data?.odometerReading != null
                                ? `${Number(data.odometerReading).toLocaleString()} km`
                                : "-"}{" "}
                            </span>{" "}
                          </td>{" "}
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {" "}
                            <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-blue-50 border border-blue-200">
                              {" "}
                              {data?.endingOdometer != null
                                ? `${Number(data.endingOdometer).toLocaleString()} km`
                                : "-"}{" "}
                            </span>{" "}
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {data?.isPaymentPending === false ? (
                              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-green-50 border border-green-200 text-green-600 text-xs font-semibold whitespace-nowrap">
                                <span className="flex items-center justify-center w-4 h-4 rounded-full bg-green-500 text-white text-[10px]">
                                  ✓
                                </span>
                                Completed
                              </span>
                            ) : (
                              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-red-50 border border-red-200 text-red-600 text-xs font-semibold whitespace-nowrap">
                                <span className="w-1.5 h-1.5 rounded-full bg-red-500" />
                                Pending
                              </span>
                            )}
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            <span className="text-[11px] font-medium">₹</span>
                            {data?.outstandingBalance || " 0"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-purple-50 border border-purple-100">
                              <span className="text-[11px] font-medium text-purple-600">
                                ₹
                              </span>

                              <span className="text-[12px] font-semibold text-purple-700">
                                {data?.insuranceClaimed != null
                                  ? Number(
                                      data.insuranceClaimed,
                                    ).toLocaleString()
                                  : "0"}
                              </span>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-red-50 border border-red-100">
                              <span className="text-[11px] font-medium text-red-600">
                                ₹
                              </span>

                              <span className="text-[12px] font-semibold text-red-700">
                                {data?.companyPaid != null
                                  ? Number(data.companyPaid).toLocaleString()
                                  : "0"}
                              </span>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-amber-50 border border-amber-100">
                              <span className="text-[11px] font-medium text-amber-600">
                                ₹
                              </span>

                              <span className="text-[12px] font-semibold text-amber-700">
                                {data?.customerPaid != null
                                  ? Number(data.customerPaid).toLocaleString()
                                  : "0"}
                              </span>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {data?.downtimeDays != null
                              ? `${data.downtimeDays} days`
                              : "-"}
                          </td>
                          <td
                            className={`px-6 py-4 text-[12px] font-bold text-right whitespace-nowrap ${
                              data?.billingDetails?.isCreditApplied
                                ? "text-[#16a34a]"
                                : "text-[#dc2626]"
                            }`}
                          >
                            {data?.billingDetails?.isCreditApplied
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <div className="self-stretch px-6 py-4 border-t border-slate-200 flex items-center justify-between bg-white">
                <div className="text-sm text-slate-500">
                  {filteredRows.length > 0 ? (
                    <>
                      Showing {startIndex + 1}-
                      {Math.min(startIndex + rowsPerPage, filteredRows.length)}{" "}
                      of {filteredRows.length}
                    </>
                  ) : (
                    "Showing 0-0 of 0"
                  )}
                </div>

                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(1, prev - 1))
                    }
                    disabled={currentPage === 1}
                    className="px-3 py-1.5 rounded-md border border-slate-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-slate-50 transition-colors"
                  >
                    Prev
                  </button>

                  <span className="text-sm text-slate-600">
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    type="button"
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                    }
                    disabled={currentPage === totalPages}
                    className="px-3 py-1.5 rounded-md border border-slate-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-slate-50 transition-colors"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
            <div className="self-stretch h-16 opacity-0 bg-zinc-300" />
          </div>
        </>
      )}
    </>
  );
};

export default Accidents;
